var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Batch No: " + _vm._s(_vm.entityName) + " "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.OrmBatchingQuotes.name,
                        params: { batchId: _vm.$route.params.batchId },
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [
                    _c("span", [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v("Batched Quotes"),
                      ]),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.count,
                            expression: "count",
                          },
                        ],
                        staticClass:
                          "has-badge-rounded has-badge-medium has-badge-info",
                        attrs: { "data-badge": _vm.count },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.OrmBatchingAvailableQuotes.name,
                        params: { batchId: _vm.$route.params.batchId },
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_c("span", [_vm._v(" Work In Progress ")])]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }